import { CancelAppointmentQueueCommand } from "@/models/club";
import useCancelAppointmentQueue from "@/services/appointment/hooks/useCancelAppointmentQueue";
import { Button, Group, Modal, Stack, Text, Textarea } from "@mantine/core";
import { useForm } from "@mantine/form";
import { notifications } from "@mantine/notifications";

type Props = {
  appointmentQueueId: number;
  close: () => void;
  opened: boolean;
};

function CancelAppointmentQueue({ appointmentQueueId, close, opened }: Props) {
  const form = useForm<CancelAppointmentQueueCommand>({
    initialValues: { appointmentQueueId, cancellationDescription: "" },
  });
  const { mutate, isLoading } = useCancelAppointmentQueue();

  return (
    <Modal opened={opened} onClose={close} title="لغو نوبت" centered>
      <form
        onSubmit={form.onSubmit((values) => {
          mutate(
            {
              appointmentQueueId,
              cancellationDescription: values.cancellationDescription?.trim() || undefined,
            },
            {
              onSuccess: () => {
                notifications.show({ color: "green", message: "نوبت با موفقیت لغو شد." });
                form.reset();
                close();
              },
            },
          );
        })}
      >
        <Stack>
          <Text size="sm">نوبت انتخاب‌شده لغو می‌شود. اگر پرداخت اسنپ‌پی باز داشته باشد، اول همان تراکنش در اسنپ‌پی لغو می‌شود.</Text>
          <Textarea
            label="توضیحات لغو"
            description="اختیاری است"
            placeholder="مثلاً درخواست مشتری"
            minRows={3}
            {...form.getInputProps("cancellationDescription")}
          />
          <Group justify="flex-end">
            <Button variant="default" onClick={close} disabled={isLoading}>انصراف</Button>
            <Button type="submit" color="red" loading={isLoading}>لغو نوبت</Button>
          </Group>
        </Stack>
      </form>
    </Modal>
  );
}

export default CancelAppointmentQueue;
